<div class="external">
    <div class="slider-container mb-2">
        <div class="slider-item" *ngFor="let image of images; let i = index "
            [ngClass]="{
                'selected': i === selectedIndex,
                'prev': i === selectedIndex - 1,
                'next': i === selectedIndex + 1,
                'hideLeft': i < selectedIndex - 1,
                'hideRight': i > selectedIndex + 1,
            }">
            <img [src]="image.imgSrc" [alt]="image.imgAlt" class="slider-img" style="height: 236px !important;">
        </div>
    </div>
    <div class="mb-4" style="    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
    bottom: -241px;
">
        <i class="pi pi-angle-left" style="font-size: 1.5rem; cursor: pointer" (click)="showPrev(selectedIndex)"></i>
        <span class="mx-1 fm-rubik">{{name}}</span>
        <i class="pi pi-angle-right" style="font-size: 1.5rem; cursor: pointer;" (click)="showNext(selectedIndex)"></i>
    </div>
</div>